//@ts-nocheck
import React, { useState } from "react";
import { Accordion, Card, CardBody, Col } from "reactstrap";
import { FlushAccordions } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FLUS_DATA, FLUS_LIST } from "../../../../Data/UiKit/Accordion";
import { StaticAccordion } from "./StaticAccordion";
import CommonAccordionItem from "../Common/CommonAccordionItem";

const FlushAccordion = () => {
  const [open, setOpen] = useState("1");
  const toggle = (id) => (open === id ? setOpen() : setOpen(id));

  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={FlushAccordions} span={FLUS_DATA} />
        <CardBody>
          <Accordion flush open={open} toggle={toggle} className="dark-accordion">
            <StaticAccordion/>
            {FLUS_LIST.map((data, index) => (
              <CommonAccordionItem item={data} key={index} />
            ))}
          </Accordion>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FlushAccordion;
